export interface GeoCoordinates {
  latitude: number;
  longitude: number;
}

/** [[minLat, minLon], [maxLat, maxLon]] — leaflet LatLngBoundsExpression order. */
export type GeoBounds = [[number, number], [number, number]];

/** Where the current position came from. `stored` means it was loaded from the API. */
export type LocationSource = 'stored' | 'geocoded' | 'manual';
export type AltitudeSource = 'auto' | 'manual';
export type LocationPrecision = 'building' | 'street' | 'area' | 'unknown';

/** The picker's form-field value. Numbers, not strings — natural for the map. */
export interface LocationValue {
  latitude: number | null;
  longitude: number | null;
  altitude: number | null;
  source: LocationSource | null;
  altitudeSource: AltitudeSource | null;
}

export const EMPTY_LOCATION_VALUE: LocationValue = {
  latitude: null,
  longitude: null,
  altitude: null,
  source: null,
  altitudeSource: null,
};

export interface AddressInput {
  street: string | null;
  city: string | null;
  postalcode: string | null;
  /** ISO-3166 alpha-2 as stored in the form; lowercased for `countrycodes`. */
  country: string | null;
}

export interface GeocodeResult {
  coordinates: GeoCoordinates;
  bounds: GeoBounds | null;
  displayName: string;
  addressType: string | null;
  placeRank: number | null;
}
